// @flow

import * as React from 'react';
import classNames from 'classnames';

import Tappable from 'app/components/commons/Tappable';
import * as cssUtils from 'app/utils/cssUtils';
import useSheet from '../../jss';

declare type Props = {
  className?: string,
  label?: string,
  onClick: () => void,
  sheet?: object,
  style?: object,
  disabled?: boolean,
  scheme?: 'dark' | 'light'
};

const defaultProps = {
  className: '',
  label: 'Reset',
  style: undefined,
  scheme: 'light',
  disabled: false
};

function ResetButton({
  className,
  label,
  onClick,
  sheet: { classes },
  style,
  scheme,
  disabled
}: Props) {
  return (
    <Tappable
      onTap={onClick}
      className={classNames(classes.button, className, scheme, { disabled })}
      style={style}
      stopPropagation
      disabled={disabled}
    >
      <span className={classNames(classes.icon, 'ion-android-cancel')} />
      {label && <span className={classes.label}>{label}</span>}
    </Tappable>
  );
}

ResetButton.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    button: {
      alignItems: 'center',
      display: 'flex',
      textTransform: 'uppercase',
      transition: 'color 0.2s',
      '&.disabled': {
        cursor: 'default !important'
      },
      '&.light': {
        color: theme.color.basis5,
        ...cssUtils.hover({
          color: theme.color.basis6
        }),
        '&.disabled': {
          color: theme.color.basis3
        }
      },
      '&.dark': {
        color: theme.color.basis3,
        ...cssUtils.hover({
          color: theme.color.basis1
        }),
        '&.disabled': {}
      }
    },
    icon: {
      fontSize: '1.5em'
    },
    label: {
      '&:before': {
        content: '"\\00a0\\00a0"'
      }
    }
  };
}

export default useSheet(applyStyles)(ResetButton);
